/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateUserReflectionEventCommand } from '../model/createUserReflectionEventCommand';
import { CreateUserReflectionEventCommandResult } from '../model/createUserReflectionEventCommandResult';
import { DeleteUserReflectionEventCommandResult } from '../model/deleteUserReflectionEventCommandResult';
import { GetAssignedReflectionsQueryResult } from '../model/getAssignedReflectionsQueryResult';
import { GetDashboardReflectionsQueryResult } from '../model/getDashboardReflectionsQueryResult';
import { GetSingleUserReflectionEventQueryResult } from '../model/getSingleUserReflectionEventQueryResult';
import { GetUserReflectionEventForChatQueryResult } from '../model/getUserReflectionEventForChatQueryResult';
import { GetUserReflectionEventQueryResult } from '../model/getUserReflectionEventQueryResult';
import { GetUserReflectionEventStatisticsQueryResult } from '../model/getUserReflectionEventStatisticsQueryResult';
import { GetUserReflectionEventsQueryResult } from '../model/getUserReflectionEventsQueryResult';
import { GetUserReflectionQuestionsQueryResult } from '../model/getUserReflectionQuestionsQueryResult';
import { GetUserReflectionStatisticsPerTypeQueryResult } from '../model/getUserReflectionStatisticsPerTypeQueryResult';
import { GetUserReflectionStatisticsQueryResult } from '../model/getUserReflectionStatisticsQueryResult';
import { GetUserReflectionSubmissionsQueryResult } from '../model/getUserReflectionSubmissionsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { ResourceScopeType } from '../model/resourceScopeType';
import { StatisticsGrouping } from '../model/statisticsGrouping';
import { SubmitAnswerCommand } from '../model/submitAnswerCommand';
import { UpdateUserQuestionAnswerCommand } from '../model/updateUserQuestionAnswerCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserReflectionEventsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [MOBILE] Gets all reflections for selected date
     * Returns all reflection events assigned to the current user for a specific date
     * @param selectedDateLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsGet(selectedDateLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionEventsQueryResult>;
    public meUserReflectionEventsGet(selectedDateLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionEventsQueryResult>>;
    public meUserReflectionEventsGet(selectedDateLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionEventsQueryResult>>;
    public meUserReflectionEventsGet(selectedDateLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (selectedDateLocal !== undefined && selectedDateLocal !== null) {
            queryParameters = queryParameters.set('SelectedDateLocal', <any>selectedDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionEventsQueryResult>('get',`${this.basePath}/Me/UserReflectionEvents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Adds a library reflection to the user&#x27;s schedule
     * Creates a Personal-scope UserReflectionEvent for the current user. The ClientUid on the command is overwritten with the JWT-derived UserUid so clients can&#x27;t assign reflections to other users.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateUserReflectionEventCommandResult>;
    public meUserReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateUserReflectionEventCommandResult>>;
    public meUserReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateUserReflectionEventCommandResult>>;
    public meUserReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateUserReflectionEventCommandResult>('post',`${this.basePath}/Me/UserReflectionEvents`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets single reflection and answers
     * Returns detailed reflection event with the user&#x27;s submitted answers for a selected date
     * @param reflectionEventUid 
     * @param submittedDateLocal 
     * @param timeZone 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsReflectionEventUidGet(reflectionEventUid: string, submittedDateLocal?: string, timeZone?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionEventQueryResult>;
    public meUserReflectionEventsReflectionEventUidGet(reflectionEventUid: string, submittedDateLocal?: string, timeZone?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionEventQueryResult>>;
    public meUserReflectionEventsReflectionEventUidGet(reflectionEventUid: string, submittedDateLocal?: string, timeZone?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionEventQueryResult>>;
    public meUserReflectionEventsReflectionEventUidGet(reflectionEventUid: string, submittedDateLocal?: string, timeZone?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reflectionEventUid === null || reflectionEventUid === undefined) {
            throw new Error('Required parameter reflectionEventUid was null or undefined when calling meUserReflectionEventsReflectionEventUidGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (submittedDateLocal !== undefined && submittedDateLocal !== null) {
            queryParameters = queryParameters.set('SubmittedDateLocal', <any>submittedDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionEventQueryResult>('get',`${this.basePath}/Me/UserReflectionEvents/${encodeURIComponent(String(reflectionEventUid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets reflection statistics
     * Returns statistical information about the current user&#x27;s reflection submissions
     * @param clientUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param scopeType 
     * @param ownershipLevelUid 
     * @param grouping 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionStatisticsQueryResult>;
    public meUserReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionStatisticsQueryResult>>;
    public meUserReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionStatisticsQueryResult>>;
    public meUserReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (scopeType !== undefined && scopeType !== null) {
            queryParameters = queryParameters.set('ScopeType', <any>scopeType);
        }
        if (ownershipLevelUid !== undefined && ownershipLevelUid !== null) {
            queryParameters = queryParameters.set('OwnershipLevelUid', <any>ownershipLevelUid);
        }
        if (grouping !== undefined && grouping !== null) {
            queryParameters = queryParameters.set('Grouping', <any>grouping);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionStatisticsQueryResult>('get',`${this.basePath}/Me/UserReflectionEvents/Statistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets submitted reflections
     * Returns all reflections submitted by the current user for a specified date range
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsSubmissionsGet(startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionSubmissionsQueryResult>;
    public meUserReflectionEventsSubmissionsGet(startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionSubmissionsQueryResult>>;
    public meUserReflectionEventsSubmissionsGet(startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionSubmissionsQueryResult>>;
    public meUserReflectionEventsSubmissionsGet(startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionSubmissionsQueryResult>('get',`${this.basePath}/Me/UserReflectionEvents/Submissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Submits reflection answers
     * Saves the user&#x27;s answers to reflection questions
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsSubmitAnswersPost(body?: SubmitAnswerCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meUserReflectionEventsSubmitAnswersPost(body?: SubmitAnswerCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meUserReflectionEventsSubmitAnswersPost(body?: SubmitAnswerCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meUserReflectionEventsSubmitAnswersPost(body?: SubmitAnswerCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Me/UserReflectionEvents/SubmitAnswers`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets reflection info for chat
     * Returns reflection name and user information for displaying in chat context
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsUidChatGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionEventForChatQueryResult>;
    public meUserReflectionEventsUidChatGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionEventForChatQueryResult>>;
    public meUserReflectionEventsUidChatGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionEventForChatQueryResult>>;
    public meUserReflectionEventsUidChatGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserReflectionEventsUidChatGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionEventForChatQueryResult>('get',`${this.basePath}/Me/UserReflectionEvents/${encodeURIComponent(String(uid))}/Chat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Removes a personal reflection assignment
     * Ends the Personal-scope reflection assignment on the day before the caller&#x27;s SelectedDateLocal (or marks it Aborted if it was added today and never answered). The underlying ReflectionEvent and all UserQuestionAnswer history are preserved. Mirrors the habit &#x27;remove from today&#x27; trashcan affordance.
     * @param uid 
     * @param selectedDateLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsUidDelete(uid: string, selectedDateLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteUserReflectionEventCommandResult>;
    public meUserReflectionEventsUidDelete(uid: string, selectedDateLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteUserReflectionEventCommandResult>>;
    public meUserReflectionEventsUidDelete(uid: string, selectedDateLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteUserReflectionEventCommandResult>>;
    public meUserReflectionEventsUidDelete(uid: string, selectedDateLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserReflectionEventsUidDelete.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (selectedDateLocal !== undefined && selectedDateLocal !== null) {
            queryParameters = queryParameters.set('SelectedDateLocal', <any>selectedDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteUserReflectionEventCommandResult>('delete',`${this.basePath}/Me/UserReflectionEvents/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Updates reflection text answer
     * Updates a specific text answer for a reflection question
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserReflectionEventsUidPut(uid: string, body?: UpdateUserQuestionAnswerCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meUserReflectionEventsUidPut(uid: string, body?: UpdateUserQuestionAnswerCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meUserReflectionEventsUidPut(uid: string, body?: UpdateUserQuestionAnswerCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meUserReflectionEventsUidPut(uid: string, body?: UpdateUserQuestionAnswerCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserReflectionEventsUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Me/UserReflectionEvents/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets assigned reflections for client
     * Returns all personal reflection events assigned to a specific client
     * @param clientUid 
     * @param startDateTimeLocal 
     * @param endDateTimeLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsGetAssignedReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAssignedReflectionsQueryResult>;
    public userReflectionEventsGetAssignedReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAssignedReflectionsQueryResult>>;
    public userReflectionEventsGetAssignedReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAssignedReflectionsQueryResult>>;
    public userReflectionEventsGetAssignedReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateTimeLocal !== undefined && startDateTimeLocal !== null) {
            queryParameters = queryParameters.set('StartDateTimeLocal', <any>startDateTimeLocal);
        }
        if (endDateTimeLocal !== undefined && endDateTimeLocal !== null) {
            queryParameters = queryParameters.set('EndDateTimeLocal', <any>endDateTimeLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetAssignedReflectionsQueryResult>('get',`${this.basePath}/UserReflectionEvents/GetAssignedReflections`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets client-dashboard reflections
     * Returns all assigned reflection events (all scopes) for a client over a date window, with the client&#x27;s sparse submitted-day marks
     * @param clientUid 
     * @param startDateTimeLocal 
     * @param endDateTimeLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsGetDashboardReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetDashboardReflectionsQueryResult>;
    public userReflectionEventsGetDashboardReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetDashboardReflectionsQueryResult>>;
    public userReflectionEventsGetDashboardReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetDashboardReflectionsQueryResult>>;
    public userReflectionEventsGetDashboardReflectionsGet(clientUid?: string, startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateTimeLocal !== undefined && startDateTimeLocal !== null) {
            queryParameters = queryParameters.set('StartDateTimeLocal', <any>startDateTimeLocal);
        }
        if (endDateTimeLocal !== undefined && endDateTimeLocal !== null) {
            queryParameters = queryParameters.set('EndDateTimeLocal', <any>endDateTimeLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetDashboardReflectionsQueryResult>('get',`${this.basePath}/UserReflectionEvents/GetDashboardReflections`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets event statistics
     * Returns statistical information for a specific assigned reflection event
     * @param uid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsGetEventStatisticsGet(uid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionEventStatisticsQueryResult>;
    public userReflectionEventsGetEventStatisticsGet(uid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionEventStatisticsQueryResult>>;
    public userReflectionEventsGetEventStatisticsGet(uid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionEventStatisticsQueryResult>>;
    public userReflectionEventsGetEventStatisticsGet(uid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (uid !== undefined && uid !== null) {
            queryParameters = queryParameters.set('Uid', <any>uid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionEventStatisticsQueryResult>('get',`${this.basePath}/UserReflectionEvents/GetEventStatistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets reflection questions and submissions
     * Returns reflection questions with client submission details for a specific day
     * @param clientUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsGetUserReflectionQuestionsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionQuestionsQueryResult>;
    public userReflectionEventsGetUserReflectionQuestionsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionQuestionsQueryResult>>;
    public userReflectionEventsGetUserReflectionQuestionsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionQuestionsQueryResult>>;
    public userReflectionEventsGetUserReflectionQuestionsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionQuestionsQueryResult>('get',`${this.basePath}/UserReflectionEvents/GetUserReflectionQuestions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets reflection statistics per type
     * Returns statistical information grouped by reflection question type
     * @param clientUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param scopeType 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsGetUserReflectionStatisticsPerTypeGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionStatisticsPerTypeQueryResult>;
    public userReflectionEventsGetUserReflectionStatisticsPerTypeGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionStatisticsPerTypeQueryResult>>;
    public userReflectionEventsGetUserReflectionStatisticsPerTypeGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionStatisticsPerTypeQueryResult>>;
    public userReflectionEventsGetUserReflectionStatisticsPerTypeGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (scopeType !== undefined && scopeType !== null) {
            queryParameters = queryParameters.set('ScopeType', <any>scopeType);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionStatisticsPerTypeQueryResult>('get',`${this.basePath}/UserReflectionEvents/GetUserReflectionStatisticsPerType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Creates reflection event for client
     * Creates and assigns a reflection event to a specific client
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateUserReflectionEventCommandResult>;
    public userReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateUserReflectionEventCommandResult>>;
    public userReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateUserReflectionEventCommandResult>>;
    public userReflectionEventsPost(body?: CreateUserReflectionEventCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateUserReflectionEventCommandResult>('post',`${this.basePath}/UserReflectionEvents`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets reflection statistics
     * Returns statistical information about the user&#x27;s reflection submissions
     * @param clientUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param scopeType 
     * @param ownershipLevelUid 
     * @param grouping 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionStatisticsQueryResult>;
    public userReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionStatisticsQueryResult>>;
    public userReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionStatisticsQueryResult>>;
    public userReflectionEventsStatisticsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, scopeType?: ResourceScopeType, ownershipLevelUid?: string, grouping?: StatisticsGrouping, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (scopeType !== undefined && scopeType !== null) {
            queryParameters = queryParameters.set('ScopeType', <any>scopeType);
        }
        if (ownershipLevelUid !== undefined && ownershipLevelUid !== null) {
            queryParameters = queryParameters.set('OwnershipLevelUid', <any>ownershipLevelUid);
        }
        if (grouping !== undefined && grouping !== null) {
            queryParameters = queryParameters.set('Grouping', <any>grouping);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionStatisticsQueryResult>('get',`${this.basePath}/UserReflectionEvents/Statistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets reflection info for chat
     * Returns reflection name and user information for displaying in chat context
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsUidChatGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserReflectionEventForChatQueryResult>;
    public userReflectionEventsUidChatGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserReflectionEventForChatQueryResult>>;
    public userReflectionEventsUidChatGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserReflectionEventForChatQueryResult>>;
    public userReflectionEventsUidChatGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userReflectionEventsUidChatGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserReflectionEventForChatQueryResult>('get',`${this.basePath}/UserReflectionEvents/${encodeURIComponent(String(uid))}/Chat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Preview user reflection event
     * Returns a preview of a single user reflection event in draft mode
     * @param uid 
     * @param clientUid 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userReflectionEventsUserReflectionEventUidGet(uid: string, clientUid?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSingleUserReflectionEventQueryResult>;
    public userReflectionEventsUserReflectionEventUidGet(uid: string, clientUid?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSingleUserReflectionEventQueryResult>>;
    public userReflectionEventsUserReflectionEventUidGet(uid: string, clientUid?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSingleUserReflectionEventQueryResult>>;
    public userReflectionEventsUserReflectionEventUidGet(uid: string, clientUid?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userReflectionEventsUserReflectionEventUidGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSingleUserReflectionEventQueryResult>('get',`${this.basePath}/UserReflectionEvents/UserReflectionEvent/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
